import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneairporttobhimashankarcabs() {



  const cardData =
  {
    keyword: 'Pune Airport to Bhimashankar Cabs',
    heading: 'Sai Trupti Cabs: Pune Airport to Bhimashankar Cabs',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune Airport to Bhimashankar cab services, designed to make your pilgrimage travel smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space for your journey. Every trip is driven by a professional, background-verified chauffeur who ensures punctual pickup from Pune Airport, courteous service, and safe, smooth driving all the way to Bhimashankar. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune Airport to Bhimashankar convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Bhimashankar with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Bhimashankar Jyotirlinga Temple",
    "description": "Bhimashankar Jyotirlinga Temple is one of the twelve sacred Jyotirlingas of Lord Shiva in India and the spiritual heart of Maharashtra. Nestled deep in the Sahyadri hills near Pune, the temple’s ancient Nagara-style architecture and self-manifested Shivalinga exude divine energy. Surrounded by dense forests and misty peaks, the site radiates peace and devotion. Pilgrims climb the stone steps with chants of 'Har Har Mahadev' echoing through the valley. The temple’s origin is linked to the legend of Lord Shiva’s battle with the demon Tripurasura, which gave rise to the sacred Bhima River. Bhimashankar is a pilgrimage where faith meets the serenity of nature."
  },
  {
    "title": "Bhimashankar Wildlife Sanctuary",
    "description": "Sprawling across 120 square kilometers, Bhimashankar Wildlife Sanctuary surrounds the temple and forms a lush green paradise for nature enthusiasts. It is home to the endangered Giant Indian Squirrel (Shekru), deer, wild boars, and numerous bird species. Thick evergreen forests, cascading streams, and rich flora make it a biodiversity hotspot. Trekkers can explore forest trails, spot rare orchids, and enjoy the crisp mountain air. The sanctuary also acts as a vital watershed for the Krishna River basin. Whether you’re a pilgrim or a wildlife lover, the sanctuary’s peaceful beauty complements the temple’s spiritual essence."
  },
  {
    "title": "Hanuman Lake",
    "description": "Located close to the temple, Hanuman Lake offers a calm and scenic escape surrounded by tall trees and chirping birds. Believed to be blessed by Lord Hanuman himself, the lake holds mythological and ecological importance. The still waters reflect the blue sky and green canopy, creating postcard-perfect views for visitors. Early mornings bring a magical mist over the lake, making it ideal for meditation, photography, or simply soaking in nature’s peace. Hanuman Lake embodies Bhimashankar’s gentle rhythm — a place where spirituality flows naturally with serenity."
  },
  {
    "title": "Nagphani Point (Duke’s Nose)",
    "description": "Nagphani Point, popularly known as Duke’s Nose due to its shape, is a breathtaking viewpoint near Bhimashankar. The name ‘Nagphani’ means ‘Cobra’s Hood,’ inspired by the cliff’s resemblance to a serpent’s head. From this vantage point, visitors can witness panoramic views of lush valleys, rolling clouds, and distant mountain peaks. It’s a popular spot for trekking and photography, especially at sunrise when the landscape glows in golden light. The journey through mist-covered trails and forested ridges adds adventure to the divine atmosphere of Bhimashankar."
  },
  {
    "title": "Gupt Bhimashankar",
    "description": "Gupt Bhimashankar, located deep within the forest, is a hidden treasure where the Bhima River is believed to emerge from the earth. A small Shiva Linga here is worshipped as the secret form of Bhimashankar. Reaching this spot requires a short trek through dense woods, adding mystery and devotion to the journey. The site is wrapped in tranquility, with the sound of gushing water and rustling leaves enhancing the spiritual aura. Gupt Bhimashankar is perfect for those who wish to experience the untouched and mystical side of the holy land."
  },
  {
    "title": "Ahupe Ghat",
    "description": "Ahupe Ghat, located near Bhimashankar, is a mesmerizing mountain pass offering one of the most panoramic views of the Western Ghats. The winding road to the top takes visitors through dense forests, waterfalls, and misty valleys. At the summit, an endless stretch of green plateaus and rugged cliffs unfolds beneath the clouds. Ahupe is a popular trekking and camping destination for adventure seekers who love offbeat travel. The silence of the wind and the majesty of the Sahyadris make this viewpoint a must-visit for anyone exploring Bhimashankar’s natural wonders."
  },
  {
    "title": "Sahyadri Trekking Trails",
    "description": "The Sahyadri Trekking Trails around Bhimashankar are a paradise for hikers and nature enthusiasts. The most famous routes — from Khandas and Bhorgiri villages — pass through waterfalls, forest canopies, and steep ascents leading to the temple. During monsoon, the entire landscape transforms into a green wonderland. Trekkers encounter hidden shrines, ancient steps, and exotic flora along the way. These trails beautifully blend adventure with spirituality, making the journey to Bhimashankar as rewarding as the destination itself. Every footstep resonates with chants, mist, and mountain charm."
  },
  {
    "title": "Sarkarwada (Old Temple Complex)",
    "description": "Sarkarwada, situated near the main temple, is an old administrative structure that once served as a resting place for travelers and priests. Today, it stands as a reminder of traditional Maratha architecture with stone walls, wooden beams, and rustic charm. The complex is surrounded by small shrines, meditation corners, and age-old banyan trees. Visitors often stop here to rest, meditate, or explore the temple’s historical roots. Sarkarwada bridges the past and present — preserving Bhimashankar’s legacy of faith, architecture, and hospitality."
  },
  {
    "title": "Bhimashankar Forest Canopy Walk",
    "description": "The Bhimashankar Forest Canopy Walk offers a thrilling way to experience the sanctuary’s natural beauty up close. Elevated wooden pathways take visitors above the forest floor, offering views of treetops, birds, and occasional glimpses of monkeys and squirrels. The sound of waterfalls, rustling leaves, and distant temple bells create a symphony of nature. The canopy walk is perfect for families and eco-tourists who want a safe yet immersive jungle experience. It’s an innovative attraction that highlights Bhimashankar’s commitment to eco-tourism and environmental awareness."
  },
  {
    "title": "Bhorgiri Fort",
    "description": "Bhorgiri Fort, located on the route to Bhimashankar, is an ancient hill fort hidden amidst the thick forest. The fort features natural caves with small Shiva shrines that pilgrims visit during treks. The path leading up offers beautiful views of waterfalls, streams, and the surrounding valleys. Though now in ruins, Bhorgiri exudes rustic charm and historical mystery. It’s a favorite among trekkers who seek both adventure and spirituality. The fort perfectly complements Bhimashankar’s sacred aura — blending myth, history, and natural splendor into one unforgettable experience."
  }
],



"services": [
  {
    "name": "Pune Airport to Bhimashankar Cabs",
    "description": "Book cabs from Pune Airport to Bhimashankar for a comfortable and scenic ride. Offers AC/non-AC options, professional drivers, luggage assistance, and flexible pickup/drop timings. Perfect for devotees, tourists, and families visiting Bhimashankar."
  },
  {
    "name": "Pune Airport to Bhimashankar Taxi Service",
    "description": "Reliable taxi service from Pune Airport to Bhimashankar with punctual pickups, AC/non-AC vehicles, professional chauffeurs, spacious seating, and luggage support. Ideal for day trips, weekend visits, and pilgrimage travel."
  },
  {
    "name": "Pune Airport Car Hire",
    "description": "Hire a car from Pune Airport to Bhimashankar with flexible travel options. Choose from Sedans, SUVs, and luxury vehicles with AC/non-AC options, professional drivers, and ample luggage space for a safe and convenient journey."
  },
  {
    "name": "Pune Airport to Bhimashankar AC Cab",
    "description": "Travel in comfort with AC cab service from Pune Airport to Bhimashankar. Includes well-maintained vehicles, professional drivers, luggage assistance, and flexible pickup/drop points for a relaxing journey."
  },
  {
    "name": "Pune Airport to Bhimashankar Non AC Cab",
    "description": "Budget-friendly non-AC cab service from Pune Airport to Bhimashankar with reliable vehicles, experienced drivers, luggage support, and flexible schedules. Ideal for economical travel without compromising comfort."
  },
  {
    "name": "Luxury Cab Pune Airport to Bhimashankar",
    "description": "Premium luxury cab service from Pune Airport to Bhimashankar with elegant interiors, AC comfort, professional chauffeurs, luggage assistance, and timely pickups. Perfect for VIP travel, special trips, or family outings."
  },
  {
    "name": "Pune Airport to Bhimashankar Innova Cab",
    "description": "Spacious Innova cab service from Pune Airport to Bhimashankar with AC/non-AC options, professional drivers, luggage support, and flexible schedules. Ideal for families, groups, and long-distance travel."
  },
  {
    "name": "Pune Airport to Bhimashankar Ertiga Cab",
    "description": "Comfortable Ertiga cab service from Pune Airport to Bhimashankar offering AC/non-AC options, professional chauffeurs, luggage support, and ample seating for small families or groups traveling to Bhimashankar."
  },
  {
    "name": "Affordable Cab Pune Airport to Bhimashankar",
    "description": "Economical cab service from Pune Airport to Bhimashankar with AC/non-AC options, professional drivers, luggage support, flexible schedules, and transparent fares for budget-conscious travelers seeking comfort."
  },
  {
    "name": "Pune Airport to Bhimashankar Outstation Cab",
    "description": "Outstation cab service from Pune Airport to Bhimashankar with AC/non-AC options, professional drivers, luggage support, flexible return schedules, and online booking for hassle-free long-distance travel."
  },
  {
    "name": "Pune Airport to Bhimashankar One Way Cab",
    "description": "Convenient one-way cab service from Pune Airport to Bhimashankar with AC/non-AC options, professional drivers, luggage assistance, and flexible pickup/drop points for cost-effective and comfortable travel."
  },
  {
    "name": "Pune Airport to Bhimashankar Drop Cab",
    "description": "Safe and punctual drop cab service from Pune Airport to Bhimashankar. Includes AC/non-AC vehicles, professional chauffeurs, luggage support, and flexible scheduling for a stress-free journey."
  },
  {
    "name": "Pune Airport to Bhimashankar Corporate Cab",
    "description": "Corporate cab service from Pune Airport to Bhimashankar with AC/non-AC vehicles, professional drivers, luggage support, flexible pickup/drop schedules, and reliable service for business trips or corporate outings."
  },
  {
    "name": "Pune Airport to Bhimashankar Wedding Cab",
    "description": "Elegant wedding cab service from Pune Airport to Bhimashankar with luxury vehicles, AC comfort, professional drivers, luggage support, and timely pickups for weddings, family events, or special occasions."
  },
  {
    "name": "Pune Airport to Bhimashankar Online Booking",
    "description": "Book cabs from Pune Airport to Bhimashankar online instantly with AC/non-AC options, professional drivers, flexible pickup/drop points, secure payments, and transparent fares for hassle-free and convenient travel."
  }
],
"tableData": [
  ["Pune Airport to Bhimashankar Cabs", "Pune Airport to Bhimashankar Taxi Service"],
  ["Pune Airport Car Hire", "Pune Airport to Bhimashankar AC Cab"],
  ["Pune Airport to Bhimashankar Non AC Cab", "Luxury Cab Pune Airport to Bhimashankar"],
  ["Pune Airport to Bhimashankar Innova Cab", "Pune Airport to Bhimashankar Ertiga Cab"],
  ["Affordable Cab Pune Airport to Bhimashankar", "Pune Airport to Bhimashankar Outstation Cab"],
  ["Pune Airport to Bhimashankar One Way Cab", "Pune Airport to Bhimashankar Drop Cab"],
  ["Pune Airport to Bhimashankar Corporate Cab", "Pune Airport to Bhimashankar Wedding Cab"],
  ["Pune Airport to Bhimashankar Online Booking", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune Airport to Bhimashankar Cabs",
    "WhyChoosedescription": "Sai Trupti Cabs  provides reliable and comfortable cab services from Pune Airport to Bhimashankar — ideal for religious trips, wildlife excursions, and leisure travel."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Get clear one-way fare estimates for Pune Airport to Bhimashankar cabs, starting at affordable rates depending on car type — no hidden charges or last-minute surprises."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, or premium cars to suit your group size, luggage, and comfort preferences for the Pune Airport–Bhimashankar route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are familiar with the Pune Airport to Bhimashankar route, ensuring a safe, smooth, and timely journey through scenic roads."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide pickups directly from Pune Airport terminals and drop-offs at Bhimashankar temple, nearby resorts, or designated locations."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All our cabs are regularly serviced, sanitized, and maintained to ensure comfort and reliability for your pilgrimage or leisure trip."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated team is available round-the-clock to assist with bookings, route planning, or any travel queries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune Airport to Bhimashankar cab easily via call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]


























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune Airport to Bhimashankar cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Pune Airport to Bhimashankar cab services for one way, round trips, and group travel.',
  },
  {
    question: 'How can I book a cab from Pune Airport to Bhimashankar with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune Airport to Bhimashankar cab through our website, mobile app, or by contacting our 24×7 customer support team for instant booking.',
  },
  {
    question: 'What types of cabs are available from Pune Airport to Bhimashankar?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers to suit your travel needs, group size, and budget.',
  },
  {
    question: 'Are the drivers experienced for Pune Airport to Bhimashankar trips?',
    answer: 'Yes, all our drivers are professional, courteous, and skilled in navigating hilly terrain and forest routes, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I hire a cab from Pune Airport to Bhimashankar for family or group trips?',
    answer: 'Certainly. Our cab services cater to family trips, group visits, and religious tours to Bhimashankar.',
  },
  {
    question: 'Is the Pune Airport to Bhimashankar cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services from Pune Airport to Bhimashankar to accommodate your travel schedule.',
  },
  {
    question: 'What are the Pune Airport to Bhimashankar cab fares?',
    answer: 'Our cab fares start from approximately ₹2,500 for sedans and ₹3,500–₹4,500 for SUVs or premium cars, depending on the vehicle type and number of passengers.',
  },
  {
    question: 'What payment options are accepted for Pune Airport to Bhimashankar cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for secure and hassle-free booking.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune Airport to Bhimashankar cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety measures to ensure a secure and comfortable journey.',
  },
  {
    question: 'Is customer support available during the Pune Airport to Bhimashankar cab ride?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Pune Airport to Bhimashankar cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Santosh Patil',
    feedback: 'I booked a Pune Airport to Bhimashankar cab with Sai Trupti Cabs. The ride was smooth and the driver was professional and courteous.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Deshmukh',
    feedback: 'Sai Trupti Cabs provided excellent service from Pune Airport to Bhimashankar. Comfortable car and timely pickup made our trip hassle-free.',
    rating: 5,
  },
];




















































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Airport to Bhimashankar Cabs",
  "image": "https://saitrupticabs.com/assets/images/pune-airport-to-bhimashankar-cab.jpg",
  "description": "Book cabs from Pune Airport to Bhimashankar for sightseeing, corporate trips, or religious visits. Choose from AC, Non-AC, Innova, Ertiga, or luxury cabs. Affordable online booking available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "3900"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1499",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-airport-to-bhimashankar-cabs"
  }
};







  return (
    <div>
      <Helmet>
  <title>Pune Airport to Bhimashankar Cabs | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book cabs from Pune Airport to Bhimashankar for sightseeing, corporate trips, or religious visits. Choose from AC, Non-AC, Innova, Ertiga, or luxury cabs. Affordable online booking available 24x7." 
  />
  <meta 
    name="keywords" 
    content="Pune Airport to Bhimashankar Cabs, Pune Airport to Bhimashankar Taxi Service, Pune Airport Car Hire, Pune Airport to Bhimashankar AC Cab, Pune Airport to Bhimashankar Non AC Cab, Luxury Cab Pune Airport to Bhimashankar, Pune Airport to Bhimashankar Innova Cab, Pune Airport to Bhimashankar Ertiga Cab, Affordable Cab Pune Airport to Bhimashankar, Pune Airport to Bhimashankar Outstation Cab, Pune Airport to Bhimashankar One Way Cab, Pune Airport to Bhimashankar Drop Cab, Pune Airport to Bhimashankar Corporate Cab, Pune Airport to Bhimashankar Wedding Cab, Pune Airport to Bhimashankar Online Booking" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/39.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Puneairporttobhimashankarcabs;